// Constant values used in the product search.
export const RATING_FILTER = 'filters[ratings][from]'
export const PRODUCER_FILTER = 'filters[producers][]'
export const TAXON_FILTER = 'filters[taxons][]'
export const MIN_PRICE_FILTER = 'filters[prices][from]'
export const MAX_PRICE_FILTER = 'filters[prices][to]'
export const SUBSCRIPTION_PLAN_FILTER = 'filters[subscription_plan_ids][]'
export const ON_SALE_FILTER = 'filters[on_sale]'
